import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '@/components/ui/accordion';
import { ContactKevinModal } from '@/components/common/ContactKevinButton';

/**
 * The portal's « Aide » tab, the only help page of the portal since W5
 * (DUP-6: the stand-alone ClientHelp page is gone, /ClientHelp redirects to
 * ?tab=help).
 *
 * The FAQ is written for the end client (viewer): it only speaks of what the
 * portal shows (calls, meetings to validate, the home figures, export, the
 * account menu). The former answers sent the client to a « Équipe » section
 * and Calendly settings it never sees. Support: « Contacter le support »
 * opens the shared form, which creates a case in the Swoft CRM.
 */

export const FAQ_IDS = ['calls', 'validate', 'figures', 'export', 'account', 'access'] as const;

export default function HelpSection() {
  const { t } = useTranslation(['dialer', 'admin']);
  const [contactOpen, setContactOpen] = useState(false);

  return (
    <div className="max-w-3xl space-y-6">
      <section aria-labelledby="portal-help-faq" className="rounded-lg border border-gray-200 bg-white p-4 sm:p-6">
        <h2 id="portal-help-faq" className="mb-2 text-base font-semibold text-gray-900">{t('admin:backoffice.help.faqTitle')}</h2>
        <Accordion type="single" collapsible>
          {FAQ_IDS.map((id) => (
            <AccordionItem key={id} value={id}>
              <AccordionTrigger className="min-h-11 text-left">{t(`admin:backoffice.help.faqs.${id}.question`)}</AccordionTrigger>
              <AccordionContent className="text-gray-600">{t(`admin:backoffice.help.faqs.${id}.answer`)}</AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </section>

      <section aria-labelledby="portal-help-support" className="rounded-lg border border-gray-200 bg-white p-4 sm:p-6">
        <h2 id="portal-help-support" className="mb-1 text-base font-semibold text-gray-900">{t('dialer:contactKevin.helpTitle')}</h2>
        <p className="mb-4 text-sm text-gray-600">{t('admin:backoffice.help.supportText')}</p>
        <Button className="min-h-11" onClick={() => setContactOpen(true)}>
          {t('dialer:contactKevin.button')}
        </Button>
      </section>

      <ContactKevinModal open={contactOpen} onOpenChange={setContactOpen} />
    </div>
  );
}
